import axiosClient from '../../api/axiosClient';
import { removeCookie, cookieEncryption } from '../../utils';
import store from '../../rematch';
import socketIo from 'socket.io-client';

const associatedAccountsModel = {
  state: {
    associatedAccountsList: [],
  },
  reducers: {
    setData(state, payload) {
      return { ...state, [payload.name]: payload.data };
    },
  },
  effects: dispatch => ({
    /**
     * Returns users associated accounts
     * @returns {Promise<void>}
     */
    async getAssociatedAccounts() {
      try {
        const response = await axiosClient.get('/auth/mentorAccountAssociations/getAssociatedAccounts');
        if (response && response.status === 200) {
          this.setData({
            name: 'associatedAccountsList',
            data: response.data.data,
          });
        }
      } catch (error) {
        console.log('error getAssociatedAccounts: ', error);
        dispatch.toastModel.showToast({
          value: 'Danger',
          message: error.message || 'Failed to fetch associated accounts',
        });
      }
    },
    /**
     * Creates new account association and updates associatedAccountsList if successful
     * @returns {Promise<any>}
     * */
    async addAssociatedAccount(data) {
      try {
        const response = await axiosClient.post('/auth/mentorAccountAssociations/addAccountAssociation', data);
        if (response && response.status === 200) {
          return { success: true };
        }
      } catch (error) {
        return { success: false, message: error?.response?.data?.msg || 'Something went wrong' };
      }
    },
    /**
     * Switches user to associated account in new session and logs them out of the previous account
     * @returns {Promise<any>}
     * */
    async switchToAssociatedAccount(accountUserId) {
      try {
        const body = { targetUserId: accountUserId };
        const response = await axiosClient.post('/auth/mentorAccountAssociations/switchToAssociatedAccount', body);
        if (response && response.status === 200) {
          const logoutData = await axiosClient.get('/auth/log-out');
          if (!logoutData.error) {
            removeCookie('userDetails');
            store.dispatch({ type: 'RESET' });
            const socket = socketIo(process.env.REACT_APP_SOCKET_API_KEY, {
              transports: ['websocket'],
            });
            socket?.close();
          }
          dispatch.authModel.setUserDetails({
            name: 'logInUser',
            data: {
              ...response?.data?.data,
              _id: response?.data?.data?.userId,
              userId: response?.data?.data?.userId,
            },
          });
          cookieEncryption('userDetails', response?.data?.data);
          return { success: true, message: 'Switched to Associated Account' };
        }
      } catch (error) {
        console.log('switch account error: ', error);
        return { success: false, message: 'Failed to switch to Associated Account' };
      }
    },
  }),
};

export default associatedAccountsModel;
